
// Method to fetch the airport data from a file
export const getAirportsData = async (cityName) => {
    try {
        const response = await fetch('./datastore/airports.json');
        if (!response.ok) {
            throw new Error('Failed to fetch airports data');
        }
        const data = await response.json();

        // Ensure the data is an array
        if (!Array.isArray(data)) {
            throw new Error('Invalid data format: expected an array of airports');
        }
        var airportInfo = data.filter(x => x.City === cityName)
        return airportInfo && airportInfo.length > 0 ? airportInfo[0] : null;
    } catch (error) {
        console.log('Error fetching airport data:', error);
        return [];
    }
};

// Utility function to find airport by IATA code from the data
export const findAirportByIATA = async (iataCode) => {
    try {
        const response = await fetch('./datastore/airports.json');
        if (!response.ok) {
            throw new Error('Failed to fetch airports data');
        }
        const data = await response.json();

        // Ensure the data is an array
        if (!Array.isArray(data)) {
            throw new Error('Invalid data format: expected an array of airports');
        }
        var airportInfo = data.filter(x => x.IATA_FAA === iataCode)
        return airportInfo && airportInfo.length > 0 ? airportInfo[0] : null;
    } catch (error) {
        console.log('Error fetching airport data:', error);
        return [];
    }
};

export function minutesDiff(dateTimeValue2, dateTimeValue1) {
    // if (!isDate(dateTimeValue2)) {
    dateTimeValue2 = new Date(dateTimeValue2)
    // }
    // if (!isDate(dateTimeValue1)) {
    dateTimeValue1 = new Date(dateTimeValue1)
    // }
    var differenceValue = (dateTimeValue2.getTime() - dateTimeValue1.getTime()) / 1000;
    differenceValue /= 60;
    var totalMinutes = Math.abs(Math.round(differenceValue));
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    return [totalMinutes, `${hours}h ${minutes}m`]
}


export const findDashboardData = (searchData, isReturnJurney) => {
    try {

        // Ensure the data is an array
        if (!Array.isArray(searchData.PricedItineraries)) {
            throw new Error('Invalid data format: expected an array of airports');
        }
        // alert(searchData.PricedItineraries.length)
        var compareDate = isReturnJurney ? searchData.ReturnDateTime : searchData.DepartureDateTime;
        var compareKey = 'ArrivalDateTime';
        var arrivalKey = 'DepartureDateTime';
        var bestPrice = searchData.PricedItineraries.map(x => {
            return x.AirItineraryPricingInfo.ItinTotalFare.TotalFare
        });
        bestPrice = bestPrice.soryArray('Amount', 'desc')
        var bestTime = [];
        searchData.PricedItineraries.map(x => {
            return x.AirItinerary.OriginDestinationOptions.OriginDestinationOption.map(x => {
                var t = x.FlightSegment.filter(y => new Date(y[compareKey]).toISOString().split('T')[0] == compareDate)
                if (t.length > 0) {
                    var _time = minutesDiff(t[0].ArrivalDateTime, t[0].DepartureDateTime)
                    bestTime.push({
                        ArrivalAirport: t[0].ArrivalAirport.LocationCode,
                        DepartureAirport: t[0].DepartureAirport.LocationCode,
                        ArrivalDateTime: t[0].ArrivalDateTime,
                        DepartureDateTime: t[0].DepartureDateTime,
                        TravelTime: _time[0],
                        TravelTimeString: _time[1],
                        FlightNumber: t[0].FlightNumber,
                        MarketingAirline: t[0].MarketingAirline.Code
                    });
                }
            })
        });
        // console.log("bestTime", bestTime)
        bestTime = bestTime.soryArray('TravelTime', 'asc')
        var _data = { bestPrice: bestPrice[0], bestTime: bestTime[0] };
        // console.log(_data)
        return _data;
    } catch (error) {
        console.log('Error fetching airport data:', error);
        return [];
    }
};

// Utility function to find airport by IATA code from the data
export const findRoutes = async (sourceCode, destinationCode, isReturnJurney) => {
    try {
        var response = await fetch('./datastore/routes.json');
        const searchData = await response.json()
        // Filter test data based on LocationCode matching the searchData
        const routesData = searchData.filter(x => x.OriginLocation == sourceCode && x.DestinationLocation == destinationCode).map(
            y => {
                return y.FlightSegment.map(f => f.LayoverAirport)
            })
        // var compareDate = isReturnJurney ? searchData.ReturnDateTime : searchData.DepartureDateTime;
        // var compareKey = 'ArrivalDateTime';
        // searchData.PricedItineraries.map(item => {
        //     return item.AirItinerary.OriginDestinationOptions.OriginDestinationOption.map(x => {
        //         var t = x.FlightSegment.filter(y => new Date(y[compareKey]).toISOString().split('T')[0] == compareDate);
        //         if (t.length > 0) {
        //             if (t[0].ArrivalAirport.LocationCode != sourceCode
        //                 && t[0].ArrivalAirport.LocationCode != destinationCode
        //                 && t[0].DepartureAirport.LocationCode != sourceCode
        //                 && t[0].DepartureAirport.LocationCode != destinationCode)
        //                 if (routesData.filter(tx => tx == t[0].ArrivalAirport.LocationCode || tx == t[0].DepartureAirport.LocationCode).length <= 0)
        //                     routesData.push(t[0].DepartureAirport.LocationCode);
        //         }
        //     })
        // });
        console.log('routesData', routesData);
        return routesData;

    } catch (error) {
        console.error('Error fetching airport data:', error);
        return null;  // Returning null to keep return types consistent
    }
};

export const getCurvedMidLatLongPoint = (fromPoint, toPoint) => {
    var offsetX = parseFloat(toPoint[1]) - parseFloat(fromPoint[1]),
        offsetY = parseFloat(toPoint[0]) - parseFloat(fromPoint[0]);

    var r = Math.sqrt(Math.pow(offsetX, 2) + Math.pow(offsetY, 2)),
        theta = Math.atan2(offsetY, offsetX);

    var thetaOffset = (3.14 / 10);

    var r2 = (r / 2) / (Math.cos(thetaOffset)),
        theta2 = theta + thetaOffset;

    var midpointX = (r2 * Math.cos(theta2)) + parseFloat(fromPoint[1]),
        midpointY = (r2 * Math.sin(theta2)) + parseFloat(fromPoint[0]);

    var midpointLatLng = [midpointY, midpointX];

    var durationBase = 2000;
    var duration = Math.sqrt(Math.log(r)) * durationBase;
    // console.log('duration', duration)
    return midpointLatLng;
}

Array.prototype.soryArray = function (key, direction) {
    return this.sort(function (a, b) {
        var keyA = a[key],
            keyB = b[key];
        // Compare the 2 dates
        if (direction == null) {
            direction = 'asc';
        }
        if (direction.toLowerCase() == 'desc') {
            if (keyA > keyB) return -1;
            if (keyA < keyB) return 1;
            return 0;
        }
        else {
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        }
    });
}

Array.prototype.equals = function (array) {
    // if the other array is a falsy value, return
    if (!array)
        return false;
    // if the argument is the same array, we can be sure the contents are same as well
    if (array === this)
        return true;
    // compare lengths - can save a lot of time 
    if (this.length != array.length)
        return false;

    for (var i = 0, l = this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].equals(array[i]))
                return false;
        }
        else if (this[i] != array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
}
